<template>
  <div>
    <navbar/>
    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Navbar";

export default {
  components: {
    navbar: Navbar
  }
};
</script>